// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"edc54813","200":"6c7836a3","399":"7ad715c6","453":"80bcb094","586":"7fa40d67","935":"9f65785e"}[chunkId] + ".chunk.js";
};